import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconSelectMultiple(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M14 9H2v2h12V9Zm0-4H2v2h12V5Zm4 8V9h-2v4h-4v2h4v4h2v-4h4v-2h-4ZM2 15h8v-2H2v2Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
